import { Typography } from "@mui/material"
import { ReactElement } from "react"

interface ILabelProps {
  paired: boolean
  label: string
}

export function StyledMuiFieldLabel(props: ILabelProps): ReactElement {
  const size = props.paired ? "80%" : "100%"
  const weight = props.paired ? "400" : "500"

  return (
    <Typography
      paddingRight="20px"
      color="#250048"
      fontSize={size}
      fontWeight={weight}
      maxWidth="200px"
      maxHeight="33px"
    >
      {props.label}
    </Typography>
  )
}
